// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../res/eventWelcome.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../res/eventSupport.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../res/eventReminder.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../res/eventEvent.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#informationsTitle {
	font-family: Silvana;
	font-weight: 300;
	font-size: 60px;
	color: var(--main-link-color);
	margin-top: 0;
	margin-bottom: 40px;
	line-height: 1em;
}

.container__lists__info {
	list-style: none;
	width: 100%;
	padding: 0;
	margin: 0;
}
.container__info {
	padding-top: 20px;
	list-style: none;
	display: flex;
	padding-bottom: 20px;
	border-bottom: 0.5px solid var(--footer-separator-color);
}



.container__svg__info {
	height: 44px;
	width: 44px;
	margin-right: 12px;
	background: var(--background-svg);
	border-radius: 50%;
	position: relative;
}

.container__svg__info span svg {
	position: absolute;
	left: 50%;
	top: 50%;
	height: auto;
	transform: translate(-50%,-50%);
	height: -webkit-fill-available;
}

.container__svg__info.active span {
	background: var(--main-hg-color);
	height: 38px;
	width: 38px;
	border-radius: 50%;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%,-50%);
}

.container__title__day__info {
	display: flex;
	justify-content: space-between;
}

.container__svg__info.active span svg {
	position: absolute;
	left: 50%;
	top: 50%;
	height: auto;
	transform: translate(-50%,-50%);
}

.container__svg__info.active {
	background: transparent;
	border: 0.5px solid var(--main-hg-color);;
}

.container__svg__info.active svg {
	fill: black;
}


.container__lists__info #informationsText {
	font-weight: 300;
	font-size: 16px;

}

.container__content__info p{
	margin: 0;
}

.container__content__info {
	width: calc(100% - 54px);
}

#informationsEvent {
	text-transform: uppercase;
	font-weight: bold;
}
#informationsEventTime {
	color: #BBBBBB;
	font-weight: 500;
	font-size: 13px;
}

#informationsText {

}

#informationsIconNew {
	background-color: var(--main-hg-color);
}

#informationsIcon {
	
}

.container__svg__info div {
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
	margin-left: auto;
	margin-right: auto;
	height: 100%;
	width: 100%;
	z-index: 9999;
	background: var(--main-hg-color);
	-webkit-mask-repeat: no-repeat;
	-webkit-box-align : center;
	-webkit-mask-position-y: center;
	-webkit-mask-position-x: center;
}

.container__svg__info.active div {
	background: #ffffff;
}

.container__info .active .footerPicto {
	background-color: var(--footer-selected-color);
}
.container__info .welcome {
	mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});

}
.container__info .support {
	mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.container__info .reminder {
	mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.container__info .event {
	mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

`, "",{"version":3,"sources":["webpack://./src/styles/informations.css"],"names":[],"mappings":"AAAA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,eAAe;CACf,6BAA6B;CAC7B,aAAa;CACb,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,UAAU;CACV,SAAS;AACV;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,aAAa;CACb,oBAAoB;CACpB,wDAAwD;AACzD;;;;AAIA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,iCAAiC;CACjC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,YAAY;CACZ,+BAA+B;CAC/B,8BAA8B;AAC/B;;AAEA;CACC,gCAAgC;CAChC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,+BAA+B;AAChC;;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,YAAY;CACZ,+BAA+B;AAChC;;AAEA;CACC,uBAAuB;CACvB,wCAAwC;AACzC;;AAEA;CACC,WAAW;AACZ;;;AAGA;CACC,gBAAgB;CAChB,eAAe;;AAEhB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;CACzB,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;;AAEA;;AAEA;CACC,sCAAsC;AACvC;;AAEA;;AAEA;;AAEA;CACC,2BAA2B;CAC3B,wBAAwB;CACxB,4BAA4B;CAC5B,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,aAAa;CACb,gCAAgC;CAChC,8BAA8B;CAC9B,0BAA0B;CAC1B,+BAA+B;CAC/B,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,8CAA8C;AAC/C;AACA;CAEC,mDAA0C;;AAE3C;AACA;CAEC,mDAA0C;AAC3C;AACA;CAEC,mDAA2C;AAC5C;AACA;CAEC,mDAAwC;AACzC","sourcesContent":["#informationsTitle {\n\tfont-family: Silvana;\n\tfont-weight: 300;\n\tfont-size: 60px;\n\tcolor: var(--main-link-color);\n\tmargin-top: 0;\n\tmargin-bottom: 40px;\n\tline-height: 1em;\n}\n\n.container__lists__info {\n\tlist-style: none;\n\twidth: 100%;\n\tpadding: 0;\n\tmargin: 0;\n}\n.container__info {\n\tpadding-top: 20px;\n\tlist-style: none;\n\tdisplay: flex;\n\tpadding-bottom: 20px;\n\tborder-bottom: 0.5px solid var(--footer-separator-color);\n}\n\n\n\n.container__svg__info {\n\theight: 44px;\n\twidth: 44px;\n\tmargin-right: 12px;\n\tbackground: var(--background-svg);\n\tborder-radius: 50%;\n\tposition: relative;\n}\n\n.container__svg__info span svg {\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\theight: auto;\n\ttransform: translate(-50%,-50%);\n\theight: -webkit-fill-available;\n}\n\n.container__svg__info.active span {\n\tbackground: var(--main-hg-color);\n\theight: 38px;\n\twidth: 38px;\n\tborder-radius: 50%;\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%,-50%);\n}\n\n.container__title__day__info {\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.container__svg__info.active span svg {\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\theight: auto;\n\ttransform: translate(-50%,-50%);\n}\n\n.container__svg__info.active {\n\tbackground: transparent;\n\tborder: 0.5px solid var(--main-hg-color);;\n}\n\n.container__svg__info.active svg {\n\tfill: black;\n}\n\n\n.container__lists__info #informationsText {\n\tfont-weight: 300;\n\tfont-size: 16px;\n\n}\n\n.container__content__info p{\n\tmargin: 0;\n}\n\n.container__content__info {\n\twidth: calc(100% - 54px);\n}\n\n#informationsEvent {\n\ttext-transform: uppercase;\n\tfont-weight: bold;\n}\n#informationsEventTime {\n\tcolor: #BBBBBB;\n\tfont-weight: 500;\n\tfont-size: 13px;\n}\n\n#informationsText {\n\n}\n\n#informationsIconNew {\n\tbackground-color: var(--main-hg-color);\n}\n\n#informationsIcon {\n\t\n}\n\n.container__svg__info div {\n\tbackground-position: center;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\theight: 100%;\n\twidth: 100%;\n\tz-index: 9999;\n\tbackground: var(--main-hg-color);\n\t-webkit-mask-repeat: no-repeat;\n\t-webkit-box-align : center;\n\t-webkit-mask-position-y: center;\n\t-webkit-mask-position-x: center;\n}\n\n.container__svg__info.active div {\n\tbackground: #ffffff;\n}\n\n.container__info .active .footerPicto {\n\tbackground-color: var(--footer-selected-color);\n}\n.container__info .welcome {\n\t-webkit-mask-image: url(\"../res/eventWelcome.svg\");\n\tmask-image: url(\"../res/eventWelcome.svg\");\n\n}\n.container__info .support {\n\t-webkit-mask-image: url(\"../res/eventSupport.svg\");\n\tmask-image: url(\"../res/eventSupport.svg\");\n}\n.container__info .reminder {\n\t-webkit-mask-image: url(\"../res/eventReminder.svg\");\n\tmask-image: url(\"../res/eventReminder.svg\");\n}\n.container__info .event {\n\t-webkit-mask-image: url(\"../res/eventEvent.svg\");\n\tmask-image: url(\"../res/eventEvent.svg\");\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
